import packageJson from '../../package.json';

const windowLocal = (window as { [key: string]: any })['env'] || {};
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: windowLocal['production'] || false,
  serviceBaseUrl: windowLocal['serviceBaseUrl'] || window.location.origin,
  csmanagement_url: windowLocal['csmanagement_url'] || window.location.origin,
  siteBaseUrl: windowLocal['siteBaseUrl'] || window.location.origin,
  publicPortalBaseUrl: windowLocal['publicPortalBaseUrl'] || window.location.origin,
  publicPortalName: windowLocal['publicPortalName'] || window.location.origin,
  authIssuer: windowLocal['authIssuer'] || window.location.origin,
  version: windowLocal['version'] || packageJson.version,
  virtualRoles: windowLocal['virtualRoles'],
  datadog_applicationId: windowLocal['datadog_applicationId'],
  datadog_clientToken: windowLocal['datadog_clientToken'],
  datadog_site: windowLocal['datadog_site'],
  datadog_service: windowLocal['datadog_service'],
  firebaseConfig_apiKey: windowLocal['firebaseConfig_apiKey'],
  firebaseConfig_projectId: windowLocal['firebaseConfig_projectId'],
  firebaseConfig_appId: windowLocal['firebaseConfig_appId'],
  googleMapId: windowLocal['googleMapId'],
  locationAccessGroupReportV2: windowLocal['locationAccessGroupReportV2'],
  auth0ClientId: windowLocal['auth0ClientId'] || '',
  auth0Issuer: windowLocal['auth0Issuer'] || '',
  auth0Audience: windowLocal['auth0Audience'] || '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
